import { Typography } from 'antd'

const { Title } = Typography

const TrainingStudentsPage = () => {
  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>Training Students</Title>
      <p>Student management functionality will be implemented here.</p>
    </div>
  )
}

export default TrainingStudentsPage